<template>
  <BaseContainer>
    <CandidateCardComplete />
  </BaseContainer>
</template>

<script>
import CandidateCardComplete from '@components/Plans/CandidateCardComplete'

export default {
  page: {
    title: 'Card saved'
  },

  components: {
    CandidateCardComplete
  }
}
</script>
